import { Category, NameValue } from 'common/models/insights-capture.model';
import { useGetCategoriesQuery } from 'common/store/api/insightsCapture.api';
import {
  selectInsightsCaptureTeamId,
  selectSelectedProfiles,
} from 'common/store/slices/insights-capture.slice';
import { useInsightsTeams } from 'modules/insights/hooks/useInsightsTeams';
import { createContext, useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';

export interface CaptureContext {
  categories: Category[];
  isLoadingCategories: boolean;
}

const CaptureContext = createContext<CaptureContext>({
  categories: [],
  isLoadingCategories: false,
});

const CaptureProvider = (props: object) => {
  const { teams } = useInsightsTeams();
  const teamId = useSelector(selectInsightsCaptureTeamId) || teams?.[0].teamID;
  const selectedProfiles = useSelector(selectSelectedProfiles);

  const { data: categories, isLoading: isLoadingCategories } = useGetCategoriesQuery(
    {
      profileIds: selectedProfiles.map((profile: NameValue) => profile.value).toString(),
      teamId: teamId,
    },
    {
      skip: selectedProfiles.length === 0 || !teamId,
      refetchOnMountOrArgChange: true,
      refetchOnReconnect: true,
    }
  );

  const value = useMemo(
    () => ({
      categories: categories ?? [],
      isLoadingCategories,
    }),
    [categories, isLoadingCategories]
  );

  return <CaptureContext.Provider value={value} {...props} />;
};

const useCaptureContext = () => useContext(CaptureContext);

export { CaptureProvider, useCaptureContext };
